<div>
    <div class="row">
        <div class="col-md-10">
            <app-page-title [title]="'The CAEL Assessment Test Takers’ Preparation Guides'"></app-page-title>
            <p>Welcome to the website for the CAEL Assessment Test Takers’ Preparation Guides. This site contains all the audio files that you need for Volumes I, II, and III.</p>
        </div>
    </div>


    <hr>
    <div class="row">
        <div class="col-md-12">
            <h3>The CAEL Assessment Test Takers’ Preparation Guide</h3>
            <div
                class="panel-group"
                id="audioPanelGroup"
                *ngFor="let audioFileGroup of listOfProductAudio;let i = index"
            >
                <div
                    *ngIf="audioFileGroup"
                    class="panel panel-default"
                >
                    <div>
                        <h4><a
                                data-toggle="collapse"
                                data-parent="#audioPanelGroup"
                                (click)="toggleCollapse(i)"
                                class="collapsed"
                                style="font-weight: normal"
                            >{{audioFileGroup.productHeader}}</a></h4>
                    </div>
                    <div
                        id="group{{i}}"
                        class="panel-collapse {{audioFileGroup.visible ? 'in' :'collapse'}}"
                    >
                        <div class="panel-body">
                            <ul
                                id="audio-container-{{audioFileGroup.productId}}"
                                class="product-audio-list"
                            >
                                <li *ngFor="let file of audioFileGroup.audioFilePaths">
                                    <p>{{extractFileDisplayName(file)}}</p>
                                    <audio
                                        data-original-name="{{file}}}}"
                                        controls="controls"
                                        preload="none"
                                        id="{{file}}"
                                        #audio
                                    >
                                        <source
                                            src="{{baseUrl}}/{{file}}"
                                            type="audio/mpeg"
                                        ></audio>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <hr>
            </div>
        </div>
    </div>
</div>
